import StickySidebar from "sticky-sidebar"
import * as jQuery from 'jquery'
import './click_handlers'
import './button_scrolling'
import mixpanel from 'mixpanel-browser';
import "../src/mixpanel_setup"

document.addEventListener("DOMContentLoaded", function(event) {
    var sidebar = new StickySidebar('#sidebar', {
        containerSelector: '#wrapper',
        innerWrapperSelector: '.sidebar__inner',
        topSpacing: 130,
        bottomSpacing: 50
    })

    const myButton = document.getElementById("topButton")
    if (myButton) {
        myButton.onclick = function() {
            goToTopOfTableOfContents()
        }
    
    // When the user scrolls down below Menu, show the button
        window.onscroll = function () { 
            scrollFunction(myButton) 
        }
    }

    mixpanel.track('Page View')

    setupClicks()
});


function scrollFunction(topButton: HTMLElement) {
    const menu = document.getElementById("menu-list");
    if (menu) {
        var menuY = menu.offsetTop;
        if (document.body.scrollTop > menuY || document.documentElement.scrollTop > menuY) {
            topButton.style.display = "flex";
        } else {
            topButton.style.display = "none";
        }
    }
}

// When the user clicks on the button, scroll to the top of the document
function goToTopOfTableOfContents() {
    const menu = document.getElementById("menu-list");
    if (!menu) { return }
    var menuY = menu.offsetTop;
    jQuery('html, body').animate({ scrollTop: menuY }, 'fast');
}

function setupClicks() {
    mixpanel.track_links("a", "Click Link")
}